export enum CustomHeaderTemplate {
  sort = 'sort',
  minMax = 'minMax'
}
